// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as BlogsRouteImport } from './routes/blogs'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DestinationsRouteImport } from './routes/destinations'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as PartnerUniversitiesRouteImport } from './routes/partner-universities'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ScholarshipsRouteImport } from './routes/scholarships'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as StyleGuideRouteImport } from './routes/style-guide'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TestimonialsRouteImport } from './routes/testimonials'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as DestinationSlugRouteImport } from './routes/destination.$slug'
import { Route as PartnersStonebridgeRouteImport } from './routes/partners.stonebridge'
import { Route as ServiceSlugRouteImport } from './routes/service.$slug'
import { Route as SettingsSanityRouteImport } from './routes/settings.sanity'
import { Route as UniversitySlugRouteImport } from './routes/university.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const BlogsRoute = BlogsRouteImport.update({
            id: '/blogs',path: '/blogs',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DestinationsRoute = DestinationsRouteImport.update({
            id: '/destinations',path: '/destinations',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const PartnerUniversitiesRoute = PartnerUniversitiesRouteImport.update({
            id: '/partner-universities',path: '/partner-universities',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ScholarshipsRoute = ScholarshipsRouteImport.update({
            id: '/scholarships',path: '/scholarships',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const StyleGuideRoute = StyleGuideRouteImport.update({
            id: '/style-guide',path: '/style-guide',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TestimonialsRoute = TestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const DestinationSlugRoute = DestinationSlugRouteImport.update({
            id: '/destination/$slug',path: '/destination/$slug',getParentRoute: () => rootRouteImport
          })
const PartnersStonebridgeRoute = PartnersStonebridgeRouteImport.update({
            id: '/partners/stonebridge',path: '/partners/stonebridge',getParentRoute: () => rootRouteImport
          })
const ServiceSlugRoute = ServiceSlugRouteImport.update({
            id: '/service/$slug',path: '/service/$slug',getParentRoute: () => rootRouteImport
          })
const SettingsSanityRoute = SettingsSanityRouteImport.update({
            id: '/settings/sanity',path: '/settings/sanity',getParentRoute: () => rootRouteImport
          })
const UniversitySlugRoute = UniversitySlugRouteImport.update({
            id: '/university/$slug',path: '/university/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,BlogsRoute: BlogsRoute,ContactRoute: ContactRoute,DestinationsRoute: DestinationsRoute,FaqRoute: FaqRoute,PartnerUniversitiesRoute: PartnerUniversitiesRoute,PrivacyRoute: PrivacyRoute,ScholarshipsRoute: ScholarshipsRoute,ServicesRoute: ServicesRoute,StyleGuideRoute: StyleGuideRoute,TermsRoute: TermsRoute,TestimonialsRoute: TestimonialsRoute,BlogSlugRoute: BlogSlugRoute,DestinationSlugRoute: DestinationSlugRoute,PartnersStonebridgeRoute: PartnersStonebridgeRoute,ServiceSlugRoute: ServiceSlugRoute,SettingsSanityRoute: SettingsSanityRoute,UniversitySlugRoute: UniversitySlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)